export default __webpack_public_path__ + "assets/webgl/picking-8.e69dce08.glb";